<template>
    <div class="profile-page">
        <section class="section-profile-cover section-shaped my-0" style="height: 21rem;">
            <div class="shape shape-style-1 shape-primary shape-skew alpha-4">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--300" no-body>
                    <div class="px-4">
                        <div class="text-center mt-5">
                            <h3>출조예약</h3>
                        </div>
                        <div class="mt-5 py-5 border-top">
                            <div style="text-align: right;">
                                <h3 class="font-sea"><b>{{ formattedPerPrice }}원</b></h3>
                            </div>
                            <div class="col-lg-12 p-0">
                                <div class="col-lg-12 p-0">
                                    <b>어종 : </b><span style="color:blue">{{ writeData.fishType }}</span> 심해 갑오징어 / Kg 급 문어
                                    <br>
                                    <b>공략방법 : </b><span style="">심해 갑오징어 낚시 / Kg 급 문어</span>
                                    <br>
                                    <b>출항일자 : </b><span style="">
                                        <a class="col-lg-12 btn-success" style="border-radius: 0.4rem;" href="https://band.us/band/92264258" target="_blank">
                                            밴드에서 출조일자 확인
                                        </a>
                                    </span>
                                    
                                </div>
                                <div class="col-lg-12 pt-3 pb-3">                                    
                                    <div class="row">
                                        <!-- <div class="col-6 pt-2 pb-2" style="background-color: #444; color:white;">
                                            {{ writeData.year }}.{{ writeData.month }}.{{ writeData.day }}({{
                                                writeData.dayText }}) 04:00 ~ 15:30
                                        </div> -->                                        
                                        <div class="col-6 pt-2 pb-2" style="background-color: #444; color:white;">
                                            동절기 06:00 ~ 15:30
                                        </div>                                        
                                        <div class="col-6 pt-2 pb-2"
                                            style="background-color: red; color:white; text-align: right;">
                                            출항 30분 전 도착 / 신분증 지참
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="row col-lg-12 p-0">
                                <div class="col-lg-12">
                                    <b>집결지 : </b> 충남 태안군 근흥면 신진도리 542 안흥외항선착장
                                </div>
                                <div class="col-lg-12">
                                    <b>제공 서비스 : </b> 점심 / 구명조끼 / 커피 / 물 / 낚시대
                                </div>
                                <div class="col-lg-12">
                                    <b>준비물 : </b> 신분증 / (동절기) 방한복
                                </div>
                            </div>
                            <div class="line"></div>
                            <div class="col-lg-12 pt-5">
                                <div class="row" style="align-items: center;">
                                    <div class="col-6 font-black p-0" style="font-size: 1.2rem;">
                                        <b>인원선택</b>
                                    </div>
                                    <div class="col-6 p-0">
                                        <div class="font-sea"
                                            style="font-size: 2rem; display: flex; align-items: center; justify-content: flex-end;">
                                            <i class="fa fa-minus-circle" style="cursor: pointer;"
                                                @click="decreasePrice"></i>
                                            <span id="per_span" class="font-black p-2" style="font-size: 1.3rem;">{{ per }} 명</span>
                                            <i class="fa fa-plus-circle" style="cursor: pointer;"
                                                @click="increasePrice"></i>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 p-4" style="background-color: rgb(16 16 16);">
                                        <div></div>
                                        <div class="font-sea pt-2 pb-2"
                                            style="display: flex; align-items: center; justify-content: space-between;">
                                            <span style="text-align: left;"><b>총 결제금액</b></span>
                                            <span style="text-align: right; font-size: x-large;"><b>{{ formattedPrice }}
                                                    원</b></span>
                                        </div>
                                        <div class="line"></div>
                                        <div class="pt-3 pb-3"
                                            style="display: flex; align-items: center; justify-content: space-between; color:white">
                                            <span style="text-align: left;"><b>예약금(100%)</b></span>
                                            <span style="text-align: right; font-size: x-large;"><b>{{ formattedPrice }}
                                                    원</b></span>
                                        </div>
                                        <div class="col-12" style="background-color: lightgray; color: black;">
                                            <div class="row">
                                                <div class="col-3 p-3"
                                                    style="background-color: gray; color: whitesmoke;">
                                                    계좌번호
                                                </div>
                                                <div class="col p-3">
                                                    농협 477141-52-034771 (예금주): 백옥현
                                                </div>
                                            </div>
                                        </div>
                                        <div class="pt-3" style="font-size: small; color:lightgray">
                                            ※<b> 예약자와 입금자가 다를 경우 하단 [입금자명]에 기재해주세요.</b>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 p-0 pt-5">
                                <div class="col-lg-12 p-0 font-black" style="font-size: 1.2rem;">
                                    <b>예약자 정보</b>
                                </div>
                                <div class="line mb-5"></div>
                                <span class="font-red"><b>※ 입금 후, 예약 확인을 반드시 네이버 밴드 출조공지에 댓글로 적어주세요(필수)</b></span>
                                <br>네이버 밴드의 출조공지 해당 일자 게시물에 댓글로 입금 확인 요청 후, <span style="color:#2DB400"><b>확인되면 예약이 확정</b></span>됩니다.
                                <br>
                                <br><b>댓글 예시)</b> 
                                <br>예약자명 / 입금자명 / 인원 수 / 휴대전화번호
                                <br><b>홍길동 / (주)홍길동 / 2명 / 010-2222-3333 입금 확인 부탁드립니다.</b>
                                <br><br>

                                <!-- ※ 예약자명의 성함/휴대전화번호를 하단에 적어주세요(필수) -->
                            </div>
                            <!-- <div class="col-lg-12 p-0 pt-2">
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-sea"
                                            style="color:white; border: thin solid skyblue;">
                                            예약자명
                                        </span>
                                    </div>
                                    <input type="text" class="form-control" v-model="name" ref="name" placeholder=" 예약자명을 입력해주세요."
                                        style="border: thin solid skyblue;">
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-sea"
                                            style="color:white; border: thin solid skyblue;">입금자명</span>
                                    </div>
                                    <input type="text" class="form-control" v-model="deposit_name" placeholder=" 예약자명과 다를 경우 입력해주세요."
                                        style="border: thin solid skyblue;">
                                </div>
                                <div class="input-group mb-3">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text bg-sea"
                                            style="color:white; border: thin solid skyblue;">휴대전화</span>
                                    </div>
                                    <input type="text" class="form-control" placeholder=" 01012345678"
                                        style="border: thin solid skyblue;" v-model="phoneNumber" ref="phoneNumber"
                                        @input="formatPhoneNumber">
                                </div>
                                <textarea type="text" class="form-control form-control-alternative" v-model="message" name="message" ref="message"
                                    placeholder="(선택) 예약 시 궁금한 점을 남겨주세요." rows="8" cols="120">
                                </textarea>
                            </div>
                            <div class="col-lg-12 btn btn-primary" @click="booking">
                                예약하기
                            </div> -->
                            <a class="col-lg-12 btn btn-primary" href="https://band.us/band/92264258" target="_blank">
                                밴드로 예약확정하러 가기
                            </a>
                            <div class="col-lg-12 p-0 pt-5">
                                <div class="col-lg-12 p-0 font-black" style="font-size: 1.2rem;">
                                    <b>취소/환불규정</b>
                                </div>
                                <div class="line mb-5"></div>
                            </div>
                            <div class="box">
                                <div class="row">
                                    <div class="col-lg-12">
                                        <div class="line-dot">
                                            <dl
                                                class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128176;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>환불금액</strong></dd>
                                                <dd>출항 5일전 100%환불</dd>
                                                <dd>출항 4일전 50%환불</dd>
                                                <dd>출항 3일전 30%환불</dd>
                                                <dd>출항 2일전부터 환불불가</dd>
                                                <dd><span class="font-red"><b>※ 환불문의는 전화로 부탁드립니다</b></span></dd>
                                                <dd>문의전화 : 010-6420-3139 태안현아호</dd>
                                            </dl>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 mt-5">
                                        <div class="line-dot">
                                            <dl
                                                class="icon icon-shape mb-5 mr-3 icon-lg icon-shape-success shadow rounded-circle">
                                                <i class="fa">&#128680;</i>
                                            </dl>
                                            <dl>
                                                <dd><strong>유의사항</strong></dd>
                                                <dd>▶출조점에서 모든 미끼.채비 등등 구입 가능 합니다.</dd>
                                                <dd>※선박 이용 지침 사항</dd>
                                                <dd>▶​기상악화와 최소인원 미달시 출조 취소될수 있는점 ​양해 부탁드립니다.</dd>
                                                <dd>▶출항시간은 일정에 따라 변동될수 있습니다.</dd>
                                                <dd>▶승선시 신분증은 꼭 지참해 주세요(미지참시 승선이 불가합니다)</dd>
                                                <dd>▶구명조끼 반드시 착용하여야합니다. (미착용 승선시 과태료 100만원)</dd>
                                                <dd>▶선박 내 음주 불가능합니다.</dd>
                                            </dl>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>
<script>
import WriteBookingJS from "@/components/writeBooking.js";
import emailJS from "@/components/emailJS/emailJS.js";

export default {
    name: "writeBooking",
    components: {
        WriteBookingJS
    },
    data() {
        return {
            writeData: WriteBookingJS.getWriteData(),
            perPrice: 100000,
            price: 0,
            per: 0,
            phoneNumber: '',
            date : "",
            name : "",
            deposit_name : "",
            message : "",
            isChk : false
        }
    },
    computed: {
        formattedPerPrice() {
            return this.perPrice.toLocaleString();
        },
        formattedPrice() {
            return this.price.toLocaleString();
        }
    },
    mounted() {
        console.log(this.writeData);
    },
    methods: {
        increasePrice() {
            this.price += 100000;
            this.per += 1;
        },
        decreasePrice() {
            if (this.price > 0) {
                this.price -= 100000;
            }

            if (this.per > 0) {
                this.per -= 1;
            }
        },
        booking() {
            this.allChk();

            if(!this.isChk){
                return 0;
            }

            emailJS.sendMail({
                "date": WriteBookingJS.getWriteData().year + "." + WriteBookingJS.getWriteData().month + "." + WriteBookingJS.getWriteData().day + " (" + WriteBookingJS.getWriteData().dayText + ")"
                , "name": this.name
                , "deposit_name": this.deposit_name
                , "amounts": this.price.toLocaleString()
                , "per": this.per
                , "phone": this.phoneNumber
                , "msg" : this.message
            });

            alert("예약 되었습니다! 입금 확인 후 예약이 확정됩니다!");
            window.close();
        },
        formatPhoneNumber() {
            // 정규표현식을 이용하여 숫자 외의 문자 제거
            let formattedNumber = this.phoneNumber.replace(/\D/g, '');

            // 11자리가 넘어가면 자르고 형식에 맞추기
            if (formattedNumber.length > 11) {
                formattedNumber = formattedNumber.slice(0, 11);
            }

            // 전화번호 형식에 맞게 변환
            this.phoneNumber = formattedNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1$2$3');
        },
        allChk(){
            this.isChk = false;
            if(!this.name){
                alert("예약자명을 입력해주세요!");
                this.$refs.message.focus();
                return false;
            }
            if(!this.phoneNumber){
                alert("휴대전화를 입력해주세요!");
                this.$refs.phonenumber.focus();
                return false;
            }
            if(this.per < 1){
                alert("인원수를 입력해주세요!");
                document.getElementById("per_span").scrollIntoView({ behavior: 'smooth', block: 'start' });
                return false;
            }
            
            this.isChk = true;

            return this.isChk;
        }
    }
}
</script>
<style>
.line {
    width: 100%;
    border-bottom: thin solid #b9bcbf;
}

.font-sea {
    color: #009fff;
}

.bg-sea {
    background-color: #009fff;
}
</style>
